import React, { useState } from 'react';
import Cards, { Focused } from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import MaskedInput from 'react-text-mask';
import creditCardType from 'credit-card-type';

export interface CardInfo {
    expiry: string;
    cvc: string;
    number: string;
    cardType: undefined | 'VISA' | 'MASTERCARD';
}

export interface CardPaymentPanelProps {
    cardInfo: CardInfo;
    set_cardInfo: React.Dispatch<React.SetStateAction<CardInfo>>;
    disabled: boolean;
}

export const CardPaymentPanel: React.FC<CardPaymentPanelProps> = (props) => {
    const [focus, set_focus] = useState<Focused>();

    const disabled = props.disabled;
    const { number, expiry, cvc } = props.cardInfo;

    const calculateCardType = (cardNumber: string) => {
        let cardType = undefined;

        const numbersOnly = cardNumber.replace(/[ _]/g, '');
        const cardTypes = creditCardType(numbersOnly);

        if (cardTypes.length === 1) {
            cardType = cardTypes[0].niceType.toUpperCase();
        }

        return cardType;
    };

    const updateCardNumber = (e) => {
        props.set_cardInfo({
            ...props.cardInfo,
            number: e.target.value,
            cardType: calculateCardType(e.target.value),
        });
    };

    return (
        <div className='payment-container'>
            <Cards
                {...props.cardInfo}
                name={' '}
                focused={focus}
                // acceptedCards={['visa','mastercard']}
            />
            <div className='payment-input-container'>
                <MaskedInput
                    type='text'
                    placeholder='Card Number'
                    name='number'
                    value={number}
                    guide={true}
                    className='payment-container-card-number'
                    mask={[
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        ' ',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        ' ',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        ' ',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                    ]}
                    onChange={updateCardNumber}
                    onFocus={(e) => set_focus(e.target.name as Focused)}
                    disabled={disabled}
                />
                <MaskedInput
                    type='text'
                    placeholder='Valid Thru'
                    name='expiry'
                    value={expiry}
                    guide={true}
                    className='payment-container-valid-thru'
                    mask={[/\d/, /\d/, '/', /\d/, /\d/]}
                    onChange={(e) =>
                        props.set_cardInfo({
                            ...props.cardInfo,
                            expiry: e.target.value,
                        })
                    }
                    onFocus={(e) => set_focus(e.target.name as Focused)}
                    disabled={disabled}
                />
                <MaskedInput
                    type='text'
                    placeholder='CVC'
                    name='cvc'
                    value={cvc}
                    guide={true}
                    className='payment-container-cvc'
                    mask={[/\d/, /\d/, /\d/]}
                    onChange={(e) =>
                        props.set_cardInfo({
                            ...props.cardInfo,
                            cvc: e.target.value,
                        })
                    }
                    onFocus={(e) => set_focus(e.target.name as Focused)}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};
